module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/index.js
// module id = 1621
// module chunks = 1